import firebase from 'firebase';
import { db, functions } from '@/firebase';
import i18n from '@/i18n.js'

export default {
    loginPhone({ state, commit }, user) {

    },
    checkLogin({ commit, rootState }, user) {
        return new Promise((resolve, reject) => {
            var resolveOnce = (doc) => {
                //resolveOnce = () => void;
                resolve(doc);
            };
            this.detacthUserFamily = db.collection('users').doc(user.uid)
                .onSnapshot((doc) => {
                    let user_db = {};
                    if (doc.exists) {
                        user_db = doc.data();
                        //reducir el objeto user a lo necesario
                    } else {
                        user_db = {
                            role: 'cliente',
                            canalRegistro: 'web',
                            fecha: new Date,
                            displayName: user.displayName,
                            email: '',
                            phoneNumber: user.phoneNumber
                        }
                        db.collection('users').doc(user.uid).set(user_db, { merge: true })
                    }
                    //reducir usuario user;
                    let user_combinado = { ...user, ...user_db };
                    if (user_combinado.direcciones) {
                        user_combinado.direcciones.filter(dir => delete dir["cacheada"]);
                    }
                    commit('setUser', user_combinado);
                    resolveOnce(user_combinado);
                }, reject)

        });
        return db.collection('users').doc(user.uid)
            .onSnapshot((doc) => {
                let user_db = {};
                if (doc.exists) {
                    user_db = doc.data();
                    //reducir el objeto user a lo necesario
                } else {
                    user_db = {
                        role: 'cliente',
                        canalRegistro: 'web',
                        fecha: new Date,
                        displayName: user.displayName,
                        email: '',
                        phoneNumber: user.phoneNumber
                    }
                    db.collection('users').doc(user.uid).set(user_db)
                }
                //reducir usuario user;
                let user_combinado = { ...user, ...user_db };
                if (user_combinado.direcciones) {
                    user_combinado.direcciones.filter(dir => delete dir["cacheada"]);
                }
                commit('setUser', user_combinado);
                return Promise.resolve();
            }, (error) => {
                console.log("error: " + error)
                //fallo de permisos, no hace falta desvincular
            })
    },
    firebaseLogout: ({ commit, dispatch }) => {
        return firebase.auth().signOut()
            .then(() => {
                commit('logout');
                commit('direcciones/resetDirCache', {}, { root: true })
                return dispatch('pedido/resetPedido', {}, { root: true })
            })
            .catch((e) => {
                console.log(e);
            })
    },
    savePerfil({ }, datos) {
        Object.keys(datos).forEach((key) => (datos[key] == null || datos[key] == '') && delete datos[key]);
        var promesas = [];
        var user = firebase.auth().currentUser;
        var p_perfil = user.updateProfile(datos)
        var p_perfil_u = db.collection('users').doc(user.uid).set(datos, { merge: true })

        promesas.push(p_perfil);
        promesas.push(p_perfil_u);

        if (datos.email) {
            var p_email = user.updateEmail(datos.email);
            var p_email_u = db.collection('users').doc(user.uid).set({ email: datos.email }, { merge: true })
            promesas.push(p_email);
            promesas.push(p_email_u);
        }
        if (datos.password) {
            var p_pass = user.updatePassword(datos.password)
            promesas.push(p_pass);
        }
        return Promise.all(promesas);

    },
    authGoogle() {
        var promesas = [];
        var provider = new firebase.auth.GoogleAuthProvider();
        return firebase.auth().signInWithPopup(provider).then(function (result) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = result.credential.accessToken;
            // The signed-in user info.
            var user = result.user;
            console.log(user);
            if (user.email) {
                var datos = {
                    displayName: user.displayName,
                    photoURL: user.photoURL,
                    email: user.email
                }
                return db.collection('users').doc(user.uid).set(datos, { merge: true })
            }
            // ...
        }).catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // The email of the user's account used.
            var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            var credential = error.credential;
            // ...
        });
    },
    sendEmail({ }) {
        var user = firebase.auth().currentUser;
        return user.sendEmailVerification().then(function (e) {
            console.log("email enviado", e)

        }).catch(function (error) {
            console.log("error al enviar el email", error)

        });
    },
    getFormasPago({ state, commit }) {
        var promesa = functions.httpsCallable('httpStripeGetFormasPago');
        return promesa()
            .then((r) => {
                commit('setFormasPago', r.data.data);
            })
            .catch((e) => { console.log(e) })
    },
    removeFormaPago({ state, commit }, payload) {
        var promesa = functions.httpsCallable('httpStripeRemoveFormaPago');
        return promesa(payload)
            .catch((e) => { console.log(e) })
    }
}